import { DesignState } from 'editor/src/store/design/types';

const setCalendarCountriesChosenByCustomerReducer = (state: DesignState) => {
  if (!state.designData) {
    return;
  }

  state.designData.calendar = {
    ...state.designData.calendar,
    countriesChosenByCustomer: true,
  };
};

export default setCalendarCountriesChosenByCustomerReducer;
